"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _TextField = _interopRequireDefault(require("../../TextField"));
var _InputComponent = _interopRequireDefault(require("./InputComponent"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["inputProps"],
  _excluded2 = ["openPicker", "disabled", "icon", "InputProps", "helperText", "error", "open", "fullWidth", "value", "placeholder", "actions", "checkPresetValue"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)({
  dateInput: {
    minWidth: '140px',
    cursor: 'pointer'
  },
  inputIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: 7,
    top: 'calc(50% - 12px)',
    pointerEvents: 'none'
  }
}, {
  name: 'DateInput'
});
var DateInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onOpen = _ref.openPicker,
    disabled = _ref.disabled,
    icon = _ref.icon,
    _ref$InputProps = _ref.InputProps,
    _ref$InputProps2 = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    inputProps = _ref$InputProps2.inputProps,
    InputProps = _objectWithoutProperties(_ref$InputProps2, _excluded),
    helperText = _ref.helperText,
    error = _ref.error,
    open = _ref.open,
    fullWidth = _ref.fullWidth,
    value = _ref.value,
    placeholder = _ref.placeholder,
    actions = _ref.actions,
    checkPresetValue = _ref.checkPresetValue,
    props = _objectWithoutProperties(_ref, _excluded2);
  var classes = useStyles();
  var valueLikePlaceholder = !value;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField["default"], _objectSpread(_objectSpread({}, props), {}, {
    value: valueLikePlaceholder ? placeholder : value,
    disabled: disabled,
    ref: ref,
    onClick: onOpen,
    error: Boolean(error),
    type: 'text',
    helperText: error ? error : helperText,
    fullWidth: fullWidth,
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      classes: {
        root: classes.dateInput
      },
      inputComponent: _InputComponent["default"],
      inputProps: _objectSpread(_objectSpread({
        actions: actions,
        valueLikePlaceholder: valueLikePlaceholder,
        icon: icon
      }, inputProps), {}, {
        iconProps: {
          classes: {
            root: classes.inputIcon
          }
        },
        open: open
      })
    })
  }));
});
DateInput.propTypes = _objectSpread(_objectSpread({}, _TextField["default"].propTypes), {}, {
  open: _propTypes["default"].bool,
  openPicker: _propTypes["default"].func
});
var _default = exports["default"] = DateInput;